import React, { FC, useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import creditCardImage from '../../../../images/payment/creditCard.png';
import translation, { world } from '../../../../languages';
import { AVAILABLE_WORLDS } from '../../../../languages/constants';
import { storageKeys } from '../../../../utils/browser-storage/storage-keys';
import cn from '../../../../utils/classnames';
import enhancedEcommerce, { PaymentOptionType } from '../../../../utils/enhanced-ecommerce';
import isProduction from '../../../../utils/is-production';
import { AVAILABLE_PAYMENT_METHODS } from '../../payment.constants';
import './old-payment-method-select.scss';
import { changeState } from '../../reducers';

type OldPaymentMethodSelectPropsType = TranslationProps & {};

const OldPaymentMethodSelect = ({ t }: OldPaymentMethodSelectPropsType) => {
    const dispatch = useDispatch();
    const user = useSelector((state: RootState) => state.main.user);
    const { activePaymentOption, paymentCart } = useSelector((state: RootState) => state.payment);

    let paymentMethods: PaymentOptionType[] =
        {
            de: [
                AVAILABLE_PAYMENT_METHODS.Invoice,
                AVAILABLE_PAYMENT_METHODS.PayPalCheckout,
                AVAILABLE_PAYMENT_METHODS.PayPalCheckoutCreditCard
            ],
            es: isProduction()
                ? [AVAILABLE_PAYMENT_METHODS.PayPalCheckoutCreditCard]
                : [AVAILABLE_PAYMENT_METHODS.PayPalCheckoutCreditCard, AVAILABLE_PAYMENT_METHODS.Invoice],
            fr: isProduction()
                ? [AVAILABLE_PAYMENT_METHODS.PayPalCheckout, AVAILABLE_PAYMENT_METHODS.PayPalCheckoutCreditCard]
                : [
                      AVAILABLE_PAYMENT_METHODS.PayPalCheckout,
                      AVAILABLE_PAYMENT_METHODS.PayPalCheckoutCreditCard,
                      AVAILABLE_PAYMENT_METHODS.Invoice
                  ],
            gr: isProduction()
                ? [AVAILABLE_PAYMENT_METHODS.PayPalCheckout, AVAILABLE_PAYMENT_METHODS.PayPalCheckoutCreditCard]
                : [
                      AVAILABLE_PAYMENT_METHODS.PayPalCheckout,
                      AVAILABLE_PAYMENT_METHODS.PayPalCheckoutCreditCard,
                      AVAILABLE_PAYMENT_METHODS.Invoice
                  ],
            it: isProduction()
                ? [AVAILABLE_PAYMENT_METHODS.PayPalCheckout, AVAILABLE_PAYMENT_METHODS.PayPalCheckoutCreditCard]
                : [
                      AVAILABLE_PAYMENT_METHODS.PayPalCheckout,
                      AVAILABLE_PAYMENT_METHODS.PayPalCheckoutCreditCard,
                      AVAILABLE_PAYMENT_METHODS.Invoice
                  ]
        }[world] || [];

    useEffect(() => {
        if (user.profileDetails) {
            const disableInvoice = user.profileDetails.details.hasUnpaidInvoiceOrders;

            if (disableInvoice) {
                paymentMethods = paymentMethods.filter((m) => m.id !== 'Invoice');
                dispatch(changeState({ activePaymentOption: paymentMethods[0] }));
            }
        }
    }, [user]);

    const choosePaymentMethod = (method: PaymentOptionType, manual?: boolean) => {
        window.storage.setItem(storageKeys.payments.lastPaymentMethod, method.id);
        dispatch(changeState({ activePaymentOption: method }));

        if (!manual) {
            enhancedEcommerce.tracker.checkoutStep2(paymentCart?.cartItems || [], method.id);
        }
    };

    useEffect(() => {
        if (paymentCart?.cartItems.length) {
            const lastMethodId = window.storage.getItem(storageKeys.payments.lastPaymentMethod);

            if (lastMethodId) {
                const method = paymentMethods.find((m) => m.id === lastMethodId) || paymentMethods[0];

                choosePaymentMethod(method);
            } else if (parseFloat(paymentCart?.finalPrice) > 7) {
                choosePaymentMethod(paymentMethods[0]);
            } else if (world === AVAILABLE_WORLDS.ES) {
                choosePaymentMethod(paymentMethods[0]);
            } else {
                choosePaymentMethod(paymentMethods[1] || paymentMethods[0]);
            }
        }
    }, [paymentCart?.loaded, paymentMethods]);

    return world === AVAILABLE_WORLDS.ES ? (
        <div className='payment-type'>
            <div>
                <div className='tsc-h2'>Proceso de pago seguro</div>
                <div className='tsc-subheadline payment-subheadline-padding'>Método de pago: tarjeta de crédito</div>
                <div className='payment-card-container'>
                    <div>
                        <img alt='credit card' className='image' src={creditCardImage} />
                    </div>
                    <div className='payment-card-text tsc-body'>Debit/Credit card</div>
                </div>
            </div>
        </div>
    ) : (
        <div
            className={cn('payment-type', {
                'no-invoice': user.profileDetails?.details.hasUnpaidInvoiceOrders
            })}
        >
            <p>
                <b>
                    {t('payment.paymentMethodSelection.title')}:{' '}
                    {activePaymentOption?.title || t('payment.paymentMethodSelection.purchaseByInvoice')}
                </b>
            </p>
            {activePaymentOption ? (
                <>
                    <div>
                        <Trans i18nKey='payment.paymentMethodSelection.subtitle1' t={t}>
                            {/*@ts-ignore*/}
                            Die Weiterleitung zu <b>{{ selectedMethod: activePaymentOption.title }}</b> erfolgt am Ende des
                            Bestellvorgangs.
                        </Trans>
                    </div>
                    <p>{t('payment.paymentMethodSelection.subtitle2')}</p>
                </>
            ) : (
                <p>{t('payment.paymentMethodSelection.subtitle3')}</p>
            )}
            {paymentMethods.map((method) => (
                <button
                    className={cn('pay-method-btn', { active: activePaymentOption?.title === method.title })}
                    key={method.id}
                    type='button'
                    onClick={() => choosePaymentMethod(method, true)}
                >
                    <img alt={method.title} src={method.img} />
                </button>
            ))}
        </div>
    );
};

const translate = translation('payment');

export default translate(OldPaymentMethodSelect);
